module.exports = __webpack_public_path__ + "images/cuprace2606eb2775aa99c0f0b18217ab974f.png";